// Schema data configurations by language
export const SCHEMA_CONFIGS = {
  "@context":"https://schema.org",
  "@graph":[
    {
      "@type":"Organization",
      "name":"Transmec",
      "alternateName":"Transmec Group",
      "legalName":"Trasporti Internazionali Transmec s.p.a.",
      "url":"https://www.transmecgroup.com/it/",
      "logo":"https://d33z3asz5zf4vc.cloudfront.net/logo_transmec_aab11a6bbc.png",
      "description":"Il Gruppo Transmec offre soluzioni di trasporto e logistica su misura dal 1850, progettate per soddisfare le esigenze specifiche di ogni cliente.\nGrazie a un'ampia gamma di servizi via strada, ferrovia, mare e aria, garantiamo affidabilità, flessibilità, rapidità ed efficienza in ogni fase della catena di fornitura.\nLa nostra attenzione alla personalizzazione ci consente di offrire soluzioni perfettamente adattate alle richieste di ciascun cliente. Allo stesso tempo, il nostro impegno per la sostenibilità ci spinge a ridurre l’impatto ambientale e a sostenere le comunità in cui operiamo.\nCon 58 sedi in Europa (Italia, Regno Unito, Romania, Francia, Germania, Irlanda, Polonia, Belgio e Spagna), Sud America (Cile), Africa (Tunisia e Marocco), Medio Oriente (Turchia) e Asia (India), operiamo senza confini in tutto il mondo.\nIn Transmec, we handle with care.",
      "slogan":"We handle with care",
      "founder":[
        {
          "@type":"Person",
          "name":"Domenico Montecchi"
        }
      ],
      "foundingDate":"1850",
      "foundingLocation":{
        "@type":"Place",
        "name":"Pavullo, Modena, Italia"
      },
      "knowsAbout":[
        "trasporto e logistica",
        "trasporto stradale",
        "trasporto intermodale",
        "trasporto aereo",
        "trasporto marittimo",
        "gestione della catena di fornitura",
        "operazioni doganali",
        "spedizioni",
        "magazzinaggio",
        "consegna dell'ultimo miglio"
      ],
      "areaServed":[
        {
          "@type":"Place",
          "name":"Europa"
        },
        {
          "@type":"Place",
          "name":"Nord Africa"
        },
        {
          "@type":"Place",
          "name":"Sud America"
        },
        {
          "@type":"Place",
          "name":"Medio Oriente"
        },
        {
          "@type":"Place",
          "name":"Asia"
        }
      ],
      "contactPoint":[
        {
          "@type":"ContactPoint",
          "url":"https://www.transmecgroup.com/it/contattaci/",
          "contactType":"customer service",
          "areaServed":"Worldwide",
          "availableLanguage":[
            "it",
            "en",
            "es",
            "ro",
            "pl",
            "fr"
          ]
        }
      ],
      "subOrganization":[
        {
          "@type":"Organization",
          "name":"T-data s.r.l.",
          "url":"https://www.t-data.it/"
        },
        {
          "@type":"Organization",
          "name":"Transmec Servizi s.p.a.",
          "url":"https://www.transmecservizi.it/"
        },
        {
          "@type":"Organization",
          "name":"Intermodal Vest S.r.l."
        },
        {
          "@type":"Organization",
          "name":"Rizo s.c.a.r.l. Consorzio Servizi"
        },
        {
          "@type":"Organization",
          "name":"S.T.C. MA S.A."
        },
        {
          "@type":"Organization",
          "name":"S.T.C. s.p.a."
        },
        {
          "@type":"Organization",
          "name":"S.T.C. TUNISIE S.A.R.L."
        },
        {
          "@type":"Organization",
          "name":"T.N.A. Cargo s.p.a."
        },
        {
          "@type":"Organization",
          "name":"Transmec Belgium s.p.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec De Bortoli Group Deutschland AG"
        },
        {
          "@type":"Organization",
          "name":"Transmec De Bortoli Group España S.A."
        },
        {
          "@type":"Organization",
          "name":"Transmec India Pvt Ltd."
        },
        {
          "@type":"Organization",
          "name":"Transmec Log s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec Overseas Chile Sa"
        },
        {
          "@type":"Organization",
          "name":"Transmec Poland Sp. z o.o."
        },
        {
          "@type":"Organization",
          "name":"Transmec Rimini s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec Ro s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec To Be s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec UK Ltd."
        },
        {
          "@type":"Organization",
          "name":"Transmec Uluslararasi Ta\u015fimacilik Tic.Ltd.\u015fti"
        },
        {
          "@type":"Organization",
          "name":"Transport International Transmec Sarl"
        }
      ],
      "brand":[
        {
          "@type":"Brand",
          "name":"Transmec Group"
        }
      ],
      "hasOfferCatalog":{
        "@type":"OfferCatalog",
        "name":"Catalogo Servizi Transmec",
        "itemListElement":[
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Trasporto Stradale"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Trasporto Intermodale"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Spedizioni marittime e aeree"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Trasporti Nord Africa"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Logistica"
            }
          }
        ]
      },
      "numberOfEmployees":"1500",
      "mainEntityOfPage":{
        "@type":"WebPage",
        "@id":"https://www.transmecgroup.com/it/il-gruppo-transmec/"
      },
      "award":[
        "Mela d'Oro (2018)"
      ],
      "keywords":"trasporti internazionali, logistica, trasporto stradale, trasporto intermodale, trasporto aereo, trasporto marittimo, operazioni doganali",
      "sameAs":[
        "https://www.facebook.com/transmecgroup",
        "https://www.youtube.com/user/TransmecGroup",
        "https://www.linkedin.com/company/transmec-group"
      ]
    },
    {
      "@type":"Organization",
      "name":"Transmec",
      "alternateName":"Transmec Group",
      "legalName":"Trasporti Internazionali Transmec s.p.a.",
      "url":"https://www.transmecgroup.com/en/",
      "logo":"https://d33z3asz5zf4vc.cloudfront.net/logo_transmec_aab11a6bbc.png",
      "description":"The Transmec Group offers tailor-made transport and logistics solutions since 1850, designed to meet the specific needs of each client.\nThanks to a wide range of road, rail, sea and air services, we guarantee reliability, flexibility, speed and efficiency at every stage of the supply chain.\nOur attention to customization allows us to provide perfectly adapted solutions to each client's requests. At the same time, our commitment to sustainability pushes us to reduce environmental impact and support the communities where we operate.\nWith 58 sites in Europe (Italy, UK, Romania, France, Germany, Ireland, Poland, Belgium and Spain), South America (Chile), Africa (Tunisia and Morocco), Middle East (Turkey) and Asia (India), we operate without boundaries worldwide.\nAt Transmec, we handle with care.",
      "slogan":"We handle with care",
      "founder":[
        {
          "@type":"Person",
          "name":"Domenico Montecchi"
        }
      ],
      "foundingDate":"1850",
      "foundingLocation":{
        "@type":"Place",
        "name":"Pavullo, Modena, Italy"
      },
      "knowsAbout":[
        "transport and logistics",
        "road transport",
        "intermodal transport",
        "air transport",
        "sea transport",
        "supply chain management",
        "customs operations",
        "freight forwarding",
        "warehousing",
        "last-mile delivery"
      ],
      "areaServed":[
        {
          "@type":"Place",
          "name":"Europe"
        },
        {
          "@type":"Place",
          "name":"North Africa"
        },
        {
          "@type":"Place",
          "name":"South America"
        },
        {
          "@type":"Place",
          "name":"Middle East"
        },
        {
          "@type":"Place",
          "name":"Asia"
        }
      ],
      "contactPoint":[
        {
          "@type":"ContactPoint",
          "url":"https://www.transmecgroup.com/en/contact-us/",
          "contactType":"customer service",
          "areaServed":"Worldwide",
          "availableLanguage":[
            "it",
            "en",
            "es",
            "ro",
            "pl",
            "fr"
          ]
        }
      ],
      "subOrganization":[
        {
          "@type":"Organization",
          "name":"T-data s.r.l.",
          "url":"https://www.t-data.it/"
        },
        {
          "@type":"Organization",
          "name":"Transmec Servizi s.p.a.",
          "url":"https://www.transmecservizi.it/"
        },
        {
          "@type":"Organization",
          "name":"Intermodal Vest S.r.l."
        },
        {
          "@type":"Organization",
          "name":"Rizo s.c.a.r.l. Consorzio Servizi"
        },
        {
          "@type":"Organization",
          "name":"S.T.C. MA S.A."
        },
        {
          "@type":"Organization",
          "name":"S.T.C. s.p.a."
        },
        {
          "@type":"Organization",
          "name":"S.T.C. TUNISIE S.A.R.L."
        },
        {
          "@type":"Organization",
          "name":"T.N.A. Cargo s.p.a."
        },
        {
          "@type":"Organization",
          "name":"Transmec Belgium s.p.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec De Bortoli Group Deutschland AG"
        },
        {
          "@type":"Organization",
          "name":"Transmec De Bortoli Group España S.A."
        },
        {
          "@type":"Organization",
          "name":"Transmec India Pvt Ltd."
        },
        {
          "@type":"Organization",
          "name":"Transmec Log s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec Overseas Chile Sa"
        },
        {
          "@type":"Organization",
          "name":"Transmec Poland Sp. z o.o."
        },
        {
          "@type":"Organization",
          "name":"Transmec Rimini s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec Ro s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec To Be s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec UK Ltd."
        },
        {
          "@type":"Organization",
          "name":"Transmec Uluslararasi Ta\u015fimacilik Tic.Ltd.\u015fti"
        },
        {
          "@type":"Organization",
          "name":"Transport International Transmec Sarl"
        }
      ],
      "brand":[
        {
          "@type":"Brand",
          "name":"Transmec Group"
        }
      ],
      "hasOfferCatalog":{
        "@type":"OfferCatalog",
        "name":"Transmec Services Catalog",
        "itemListElement":[
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Road Transport"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Intermodal Transport"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Sea and Air Shipping"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"North Africa Transport"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Logistics"
            }
          }
        ]
      },
      "numberOfEmployees":"1500",
      "mainEntityOfPage":{
        "@type":"WebPage",
        "@id":"https://www.transmecgroup.com/en/transmec-group/"
      },
      "award":[
        "Mela d'Oro (2018)"
      ],
      "keywords":"international transport, logistics, road transport, intermodal transport, air transport, sea transport, customs operations",
      "sameAs":[
        "https://www.facebook.com/transmecgroup",
        "https://www.youtube.com/user/TransmecGroup",
        "https://www.linkedin.com/company/transmec-group"
      ]
    },
    {
      "@type":"Organization",
      "name":"Transmec",
      "alternateName":"Transmec Group",
      "legalName":"Trasporti Internazionali Transmec s.p.a.",
      "url":"https://www.transmecgroup.com/fr/",
      "logo":"https://d33z3asz5zf4vc.cloudfront.net/logo_transmec_aab11a6bbc.png",
      "description":"Le Groupe Transmec propose des solutions de transport et de logistique sur mesure depuis 1850, conçues pour répondre aux besoins spécifiques de chaque client.\nGrâce à une large gamme de services routiers, ferroviaires, maritimes et aériens, nous garantissons fiabilité, flexibilité, rapidité et efficacité à chaque étape de la chaîne d'approvisionnement.\nNotre attention à la personnalisation nous permet d'offrir des solutions parfaitement adaptées aux demandes de chaque client. En même temps, notre engagement pour la durabilité nous pousse à réduire l'impact environnemental et à soutenir les communautés où nous opérons.\nAvec 58 sites en Europe (Italie, Royaume-Uni, Roumanie, France, Allemagne, Irlande, Pologne, Belgique et Espagne), Amérique du Sud (Chili), Afrique (Tunisie et Maroc), Moyen-Orient (Turquie) et Asie (Inde), nous opérons sans frontières dans le monde entier.\nChez Transmec, nous prenons soin de vos marchandises.",
      "slogan":"We handle with care",
      "founder":[
        {
          "@type":"Person",
          "name":"Domenico Montecchi"
        }
      ],
      "foundingDate":"1850",
      "foundingLocation":{
        "@type":"Place",
        "name":"Pavullo, Modène, Italie"
      },
      "knowsAbout":[
        "transport et logistique",
        "transport routier",
        "transport intermodal",
        "transport aérien",
        "transport maritime",
        "gestion de la chaîne d'approvisionnement",
        "opérations douanières",
        "expédition de marchandises",
        "entreposage",
        "livraison du dernier kilomètre"
      ],
      "areaServed":[
        {
          "@type":"Place",
          "name":"Europe"
        },
        {
          "@type":"Place",
          "name":"Afrique du Nord"
        },
        {
          "@type":"Place",
          "name":"Amérique du Sud"
        },
        {
          "@type":"Place",
          "name":"Moyen-Orient"
        },
        {
          "@type":"Place",
          "name":"Asie"
        }
      ],
      "contactPoint":[
        {
          "@type":"ContactPoint",
          "url":"https://www.transmecgroup.com/fr/contactez-nous/",
          "contactType":"customer service",
          "areaServed":"Worldwide",
          "availableLanguage":[
            "it",
            "en",
            "es",
            "ro",
            "pl",
            "fr"
          ]
        }
      ],
      "subOrganization":[
        {
          "@type":"Organization",
          "name":"T-data s.r.l.",
          "url":"https://www.t-data.it/"
        },
        {
          "@type":"Organization",
          "name":"Transmec Servizi s.p.a.",
          "url":"https://www.transmecservizi.it/"
        },
        {
          "@type":"Organization",
          "name":"Intermodal Vest S.r.l."
        },
        {
          "@type":"Organization",
          "name":"Rizo s.c.a.r.l. Consorzio Servizi"
        },
        {
          "@type":"Organization",
          "name":"S.T.C. MA S.A."
        },
        {
          "@type":"Organization",
          "name":"S.T.C. s.p.a."
        },
        {
          "@type":"Organization",
          "name":"S.T.C. TUNISIE S.A.R.L."
        },
        {
          "@type":"Organization",
          "name":"T.N.A. Cargo s.p.a."
        },
        {
          "@type":"Organization",
          "name":"Transmec Belgium s.p.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec De Bortoli Group Deutschland AG"
        },
        {
          "@type":"Organization",
          "name":"Transmec De Bortoli Group España S.A."
        },
        {
          "@type":"Organization",
          "name":"Transmec India Pvt Ltd."
        },
        {
          "@type":"Organization",
          "name":"Transmec Log s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec Overseas Chile Sa"
        },
        {
          "@type":"Organization",
          "name":"Transmec Poland Sp. z o.o."
        },
        {
          "@type":"Organization",
          "name":"Transmec Rimini s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec Ro s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec To Be s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec UK Ltd."
        },
        {
          "@type":"Organization",
          "name":"Transmec Uluslararasi Ta\u015fimacilik Tic.Ltd.\u015fti"
        },
        {
          "@type":"Organization",
          "name":"Transport International Transmec Sarl"
        }
      ],
      "brand":[
        {
          "@type":"Brand",
          "name":"Transmec Group"
        }
      ],
      "hasOfferCatalog":{
        "@type":"OfferCatalog",
        "name":"Catalogue des services Transmec",
        "itemListElement":[
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Transport routier"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Transport intermodal"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Expéditions maritime et aérienne"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Transport en Afrique du Nord"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Logistique"
            }
          }
        ]
      },
      "numberOfEmployees":"1500",
      "mainEntityOfPage":{
        "@type":"WebPage",
        "@id":"https://www.transmecgroup.com/fr/le-groupe-transmec/"
      },
      "award":[
        "Mela d'Oro (2018)"
      ],
      "keywords":"transport international, logistique, transport routier, transport intermodal, transport aérien, transport maritime, opérations douanières",
      "sameAs":[
        "https://www.facebook.com/transmecgroup",
        "https://www.youtube.com/user/TransmecGroup",
        "https://www.linkedin.com/company/transmec-group"
      ]
    },
    {
      "@type":"Organization",
      "name":"Transmec",
      "alternateName":"Transmec Group",
      "legalName":"Trasporti Internazionali Transmec s.p.a.",
      "url":"https://www.transmecgroup.com/es/",
      "logo":"https://d33z3asz5zf4vc.cloudfront.net/logo_transmec_aab11a6bbc.png",
      "description":"El Grupo Transmec ofrece soluciones de transporte y logística a medida desde 1850, diseñadas para satisfacer las necesidades específicas de cada cliente.\nGracias a una amplia gama de servicios por carretera, ferrocarril, mar y aire, garantizamos fiabilidad, flexibilidad, rapidez y eficacia en cada etapa de la cadena de suministro.\nNuestra atención a la personalización nos permite ofrecer soluciones perfectamente adaptadas a las solicitudes de cada cliente. Al mismo tiempo, nuestro compromiso con la sostenibilidad nos impulsa a reducir el impacto ambiental y apoyar a las comunidades donde operamos.\nCon 58 sedes en Europa (Italia, Reino Unido, Rumania, Francia, Alemania, Irlanda, Polonia, Bélgica y España), América del Sur (Chile), África (Túnez y Marruecos), Medio Oriente (Turquía) y Asia (India), operamos sin fronteras en todo el mundo.\nEn Transmec, cuidamos con responsabilidad.",
      "slogan":"We handle with care",
      "founder":[
        {
          "@type":"Person",
          "name":"Domenico Montecchi"
        }
      ],
      "foundingDate":"1850",
      "foundingLocation":{
        "@type":"Place",
        "name":"Pavullo, Módena, Italia"
      },
      "knowsAbout":[
        "transporte y logística",
        "transporte por carretera",
        "transporte intermodal",
        "transporte aéreo",
        "transporte marítimo",
        "gestión de la cadena de suministro",
        "operaciones aduaneras",
        "transporte de mercancías",
        "almacenamiento",
        "entrega de última milla"
      ],
      "areaServed":[
        {
          "@type":"Place",
          "name":"Europa"
        },
        {
          "@type":"Place",
          "name":"Norte de África"
        },
        {
          "@type":"Place",
          "name":"Sudamérica"
        },
        {
          "@type":"Place",
          "name":"Medio Oriente"
        },
        {
          "@type":"Place",
          "name":"Asia"
        }
      ],
      "contactPoint":[
        {
          "@type":"ContactPoint",
          "url":"https://www.transmecgroup.com/es/contactanos/",
          "contactType":"customer service",
          "areaServed":"Worldwide",
          "availableLanguage":[
            "it",
            "en",
            "es",
            "ro",
            "pl",
            "fr"
          ]
        }
      ],
      "subOrganization":[
        {
          "@type":"Organization",
          "name":"T-data s.r.l.",
          "url":"https://www.t-data.it/"
        },
        {
          "@type":"Organization",
          "name":"Transmec Servizi s.p.a.",
          "url":"https://www.transmecservizi.it/"
        },
        {
          "@type":"Organization",
          "name":"Intermodal Vest S.r.l."
        },
        {
          "@type":"Organization",
          "name":"Rizo s.c.a.r.l. Consorzio Servizi"
        },
        {
          "@type":"Organization",
          "name":"S.T.C. MA S.A."
        },
        {
          "@type":"Organization",
          "name":"S.T.C. s.p.a."
        },
        {
          "@type":"Organization",
          "name":"S.T.C. TUNISIE S.A.R.L."
        },
        {
          "@type":"Organization",
          "name":"T.N.A. Cargo s.p.a."
        },
        {
          "@type":"Organization",
          "name":"Transmec Belgium s.p.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec De Bortoli Group Deutschland AG"
        },
        {
          "@type":"Organization",
          "name":"Transmec De Bortoli Group España S.A."
        },
        {
          "@type":"Organization",
          "name":"Transmec India Pvt Ltd."
        },
        {
          "@type":"Organization",
          "name":"Transmec Log s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec Overseas Chile Sa"
        },
        {
          "@type":"Organization",
          "name":"Transmec Poland Sp. z o.o."
        },
        {
          "@type":"Organization",
          "name":"Transmec Rimini s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec Ro s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec To Be s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec UK Ltd."
        },
        {
          "@type":"Organization",
          "name":"Transmec Uluslararasi Ta\u015fimacilik Tic.Ltd.\u015fti"
        },
        {
          "@type":"Organization",
          "name":"Transport International Transmec Sarl"
        }
      ],
      "brand":[
        {
          "@type":"Brand",
          "name":"Transmec Group"
        }
      ],
      "hasOfferCatalog":{
        "@type":"OfferCatalog",
        "name":"Catálogo de servicios Transmec",
        "itemListElement":[
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Transporte por carretera"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Transporte intermodal"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Envíos marítimos y aéreos"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Transporte en África del Norte"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Logística"
            }
          }
        ]
      },
      "numberOfEmployees":"1500",
      "mainEntityOfPage":{
        "@type":"WebPage",
        "@id":"https://www.transmecgroup.com/es/el-grupo-transmec/"
      },
      "award":[
        "Mela d'Oro (2018)"
      ],
      "keywords":"transporte internacional, logística, transporte por carretera, transporte intermodal, transporte aéreo, transporte marítimo, operaciones aduaneras",
      "sameAs":[
        "https://www.facebook.com/transmecgroup",
        "https://www.youtube.com/user/TransmecGroup",
        "https://www.linkedin.com/company/transmec-group"
      ]
    },
    {
      "@type":"Organization",
      "name":"Transmec",
      "alternateName":"Transmec Group",
      "legalName":"Trasporti Internazionali Transmec s.p.a.",
      "url":"https://www.transmecgroup.com/ro/",
      "logo":"https://d33z3asz5zf4vc.cloudfront.net/logo_transmec_aab11a6bbc.png",
      "description":"Grupul Transmec oferă soluții personalizate de transport și logistică din 1850, concepute pentru a satisface nevoile specifice ale fiecărui client.\nCu o gamă largă de servicii rutiere, feroviare, maritime și aeriene, asigurăm fiabilitate, flexibilitate, rapiditate și eficiență în fiecare etapă a lanțului de aprovizionare.\nAtenția noastră pentru personalizare ne permite să oferim soluții perfect adaptate cerințelor fiecărui client. În același timp, angajamentul nostru față de durabilitate ne determină să reducem impactul asupra mediului și să susținem comunitățile în care activăm.\nCu 58 de sedi în Europa (Italia, Regatul Unit, România, Franța, Germania, Irlanda, Polonia, Belgia și Spania), America de Sud (Chile), Africa (Tunisia și Maroc), Orientul Mijlociu (Turcia) și Asia (India), operăm fără frontiere în întreaga lume.\nLa Transmec, avem grijă cu atenție.",
      "slogan":"We handle with care",
      "founder":[
        {
          "@type":"Person",
          "name":"Domenico Montecchi"
        }
      ],
      "foundingDate":"1850",
      "foundingLocation":{
        "@type":"Place",
        "name":"Pavullo, Modena, Italia"
      },
      "knowsAbout":[
        "transport și logistică",
        "transport rutier",
        "transport intermodal",
        "transport aerian",
        "transport maritim",
        "gestionarea lanțului de aprovizionare",
        "operațiuni vamale",
        "expedierea mărfurilor",
        "depozitare",
        "livrare ultimul kilometru"
      ],
      "areaServed":[
        {
          "@type":"Place",
          "name":"Europa"
        },
        {
          "@type":"Place",
          "name":"Nord Africa"
        },
        {
          "@type":"Place",
          "name":"Sud America"
        },
        {
          "@type":"Place",
          "name":"Medio Oriente"
        },
        {
          "@type":"Place",
          "name":"Asia"
        }
      ],
      "contactPoint":[
        {
          "@type":"ContactPoint",
          "url":"https://www.transmecgroup.com/ro/contactati-ne/",
          "contactType":"customer service",
          "areaServed":"Worldwide",
          "availableLanguage":[
            "it",
            "en",
            "es",
            "ro",
            "pl",
            "fr"
          ]
        }
      ],
      "subOrganization":[
        {
          "@type":"Organization",
          "name":"T-data s.r.l.",
          "url":"https://www.t-data.it/"
        },
        {
          "@type":"Organization",
          "name":"Transmec Servizi s.p.a.",
          "url":"https://www.transmecservizi.it/"
        },
        {
          "@type":"Organization",
          "name":"Intermodal Vest S.r.l."
        },
        {
          "@type":"Organization",
          "name":"Rizo s.c.a.r.l. Consorzio Servizi"
        },
        {
          "@type":"Organization",
          "name":"S.T.C. MA S.A."
        },
        {
          "@type":"Organization",
          "name":"S.T.C. s.p.a."
        },
        {
          "@type":"Organization",
          "name":"S.T.C. TUNISIE S.A.R.L."
        },
        {
          "@type":"Organization",
          "name":"T.N.A. Cargo s.p.a."
        },
        {
          "@type":"Organization",
          "name":"Transmec Belgium s.p.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec De Bortoli Group Deutschland AG"
        },
        {
          "@type":"Organization",
          "name":"Transmec De Bortoli Group España S.A."
        },
        {
          "@type":"Organization",
          "name":"Transmec India Pvt Ltd."
        },
        {
          "@type":"Organization",
          "name":"Transmec Log s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec Overseas Chile Sa"
        },
        {
          "@type":"Organization",
          "name":"Transmec Poland Sp. z o.o."
        },
        {
          "@type":"Organization",
          "name":"Transmec Rimini s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec Ro s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec To Be s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec UK Ltd."
        },
        {
          "@type":"Organization",
          "name":"Transmec Uluslararasi Ta\u015fimacilik Tic.Ltd.\u015fti"
        },
        {
          "@type":"Organization",
          "name":"Transport International Transmec Sarl"
        }
      ],
      "brand":[
        {
          "@type":"Brand",
          "name":"Transmec Group"
        }
      ],
      "hasOfferCatalog":{
        "@type":"OfferCatalog",
        "name":"Catalog Servicii Transmec",
        "itemListElement":[
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Transport rutier"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Transport intermodal"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Expediții maritime și aeriene"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Transport în Africa de Nord"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Logistică"
            }
          }
        ]
      },
      "numberOfEmployees":"1500",
      "mainEntityOfPage":{
        "@type":"WebPage",
        "@id":"https://www.transmecgroup.com/ro/grupul-transmec/"
      },
      "award":[
        "Mela d'Oro (2018)"
      ],
      "keywords":"transport internațional, logistică, transport rutier, transport intermodal, transport aerian, transport maritim, operațiuni vamale",
      "sameAs":[
        "https://www.facebook.com/transmecgroup",
        "https://www.youtube.com/user/TransmecGroup",
        "https://www.linkedin.com/company/transmec-group"
      ]
    },
    {
      "@type":"Organization",
      "name":"Transmec",
      "alternateName":"Transmec Group",
      "legalName":"Trasporti Internazionali Transmec s.p.a.",
      "url":"https://www.transmecgroup.com/pl/",
      "logo":"https://d33z3asz5zf4vc.cloudfront.net/logo_transmec_aab11a6bbc.png",
      "description":"Grupa Transmec oferuje dostosowane rozwiązania transportowe i logistyczne od 1850 roku, zaprojektowane tak, aby sprostać specyficznym potrzebom każdego klienta.\nDzięki szerokiej gamie usług drogowych, kolejowych, morskich i lotniczych zapewniamy niezawodność, elastyczność, szybkość i efektywność na każdym etapie łańcucha dostaw.\nNasze podejście do personalizacji pozwala oferować rozwiązania idealnie dopasowane do potrzeb klienta. Jednocześnie nasze zaangażowanie na rzecz zrównoważonego rozwoju skłania nas do zmniejszania wpływu na środowisko i wspierania społeczności, w których działamy.\nZ 58 oddziałami w Europie (Włochy, Wielka Brytania, Rumunia, Francja, Niemcy, Irlandia, Polska, Belgia i Hiszpania), Ameryce Południowej (Chile), Afryce (Tunezja i Maroko), na Bliskim Wschodzie (Turcja) i w Azji (Indie), działamy bez granic na całym świecie.\nW Transmec dbamy z troską.",
      "slogan":"We handle with care",
      "founder":[
        {
          "@type":"Person",
          "name":"Domenico Montecchi"
        }
      ],
      "foundingDate":"1850",
      "foundingLocation":{
        "@type":"Place",
        "name":"Pavullo, Modena, Włochy"
      },
      "knowsAbout":[
        "transport i logistyka",
        "transport drogowy",
        "transport intermodalny",
        "transport lotniczy",
        "transport morski",
        "zarządzanie łańcuchem dostaw",
        "operacje celne",
        "spedycja",
        "magazynowanie",
        "dostawa ostatniej mili"
      ],
      "areaServed":[
        {
          "@type":"Place",
          "name":"Europa"
        },
        {
          "@type":"Place",
          "name":"Afryka Północna"
        },
        {
          "@type":"Place",
          "name":"Ameryka Południowa"
        },
        {
          "@type":"Place",
          "name":"Bliski Wschód"
        },
        {
          "@type":"Place",
          "name":"Azja"
        }
      ],
      "contactPoint":[
        {
          "@type":"ContactPoint",
          "url":"https://www.transmecgroup.com/pl/skontaktuj-sie-z-nami/",
          "contactType":"customer service",
          "areaServed":"Worldwide",
          "availableLanguage":[
            "it",
            "en",
            "es",
            "ro",
            "pl",
            "fr"
          ]
        }
      ],
      "subOrganization":[
        {
          "@type":"Organization",
          "name":"T-data s.r.l.",
          "url":"https://www.t-data.it/"
        },
        {
          "@type":"Organization",
          "name":"Transmec Servizi s.p.a.",
          "url":"https://www.transmecservizi.it/"
        },
        {
          "@type":"Organization",
          "name":"Intermodal Vest S.r.l."
        },
        {
          "@type":"Organization",
          "name":"Rizo s.c.a.r.l. Consorzio Servizi"
        },
        {
          "@type":"Organization",
          "name":"S.T.C. MA S.A."
        },
        {
          "@type":"Organization",
          "name":"S.T.C. s.p.a."
        },
        {
          "@type":"Organization",
          "name":"S.T.C. TUNISIE S.A.R.L."
        },
        {
          "@type":"Organization",
          "name":"T.N.A. Cargo s.p.a."
        },
        {
          "@type":"Organization",
          "name":"Transmec Belgium s.p.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec De Bortoli Group Deutschland AG"
        },
        {
          "@type":"Organization",
          "name":"Transmec De Bortoli Group España S.A."
        },
        {
          "@type":"Organization",
          "name":"Transmec India Pvt Ltd."
        },
        {
          "@type":"Organization",
          "name":"Transmec Log s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec Overseas Chile Sa"
        },
        {
          "@type":"Organization",
          "name":"Transmec Poland Sp. z o.o."
        },
        {
          "@type":"Organization",
          "name":"Transmec Rimini s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec Ro s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec To Be s.r.l."
        },
        {
          "@type":"Organization",
          "name":"Transmec UK Ltd."
        },
        {
          "@type":"Organization",
          "name":"Transmec Uluslararasi Ta\u015fimacilik Tic.Ltd.\u015fti"
        },
        {
          "@type":"Organization",
          "name":"Transport International Transmec Sarl"
        }
      ],
      "brand":[
        {
          "@type":"Brand",
          "name":"Transmec Group"
        }
      ],
      "hasOfferCatalog":{
        "@type":"OfferCatalog",
        "name":"Katalog usług Transmec",
        "itemListElement":[
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Transport drogowy"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Transport intermodalny"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Wysyłki morskie i lotnicze"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Transport Afryka Północna"
            }
          },
          {
            "@type":"Offer",
            "itemOffered":{
              "@type":"Service",
              "name":"Logistyka"
            }
          }
        ]
      },
      "numberOfEmployees":"1500",
      "mainEntityOfPage":{
        "@type":"WebPage",
        "@id":"https://www.transmecgroup.com/pl/grupa-transmec/"
      },
      "award":[
        "Mela d'Oro (2018)"
      ],
      "keywords":"transport międzynarodowy, logistyka, transport drogowy, transport intermodalny, transport lotniczy, transport morski, operacje celne",
      "sameAs":[
        "https://www.facebook.com/transmecgroup",
        "https://www.youtube.com/user/TransmecGroup",
        "https://www.linkedin.com/company/transmec-group"
      ]
    }
  ]
}